import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function TrustSection() {
  return <section id="trust" className="py-24 bg-dark-900 border-t border-white/5" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-271">
          {/* Left Content */}
          <div data-id="element-272">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-273">
              安全可靠，
              <br data-id="element-274" />
              <span className="text-gold-500" data-id="element-275">值得信赖</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-276">
              IsYou
              致力于为您提供最安全、最私密的高端伴游服务。我们深知隐私与安全的重要性，因此建立了严格的审核与保障机制。
            </p>

            <div className="space-y-6" data-id="element-277">
              <div className="flex items-start" data-id="element-278">
                <div className="flex-shrink-0 mt-1" data-id="element-279">
                  <ShieldCheck className="w-6 h-6 text-gold-500" data-id="element-280" />
                </div>
                <div className="ml-4" data-id="element-281">
                  <h4 className="text-lg font-bold text-white" data-id="element-282">真人核验</h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-283">
                    所有伴游女郎均经过严格的身份核验和线下面试，杜绝照骗。
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-284">
                <div className="flex-shrink-0 mt-1" data-id="element-285">
                  <Lock className="w-6 h-6 text-gold-500" data-id="element-286" />
                </div>
                <div className="ml-4" data-id="element-287">
                  <h4 className="text-lg font-bold text-white" data-id="element-288">隐私保护</h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-289">
                    采用端到端加密技术，严格保护您的个人信息与行程隐私。
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-290">
                <div className="flex-shrink-0 mt-1" data-id="element-291">
                  <CreditCard className="w-6 h-6 text-gold-500" data-id="element-292" />
                </div>
                <div className="ml-4" data-id="element-293">
                  <h4 className="text-lg font-bold text-white" data-id="element-294">满意付款</h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-295">
                    见面满意后付款，不满意可随时取消，资金安全有保障。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image/Graphic */}
          <div className="relative" data-id="element-296">
            <div className="absolute inset-0 bg-gold-500/20 blur-[100px] rounded-full" data-id="element-297"></div>
            <div className="relative bg-dark-800 border border-white/10 rounded-2xl p-8 md:p-12" data-id="element-298">
              <div className="text-center mb-8" data-id="element-299">
                <div className="text-6xl font-serif font-bold text-gold-500 mb-2" data-id="element-300">
                  100%
                </div>
                <div className="text-white text-lg" data-id="element-301">客户满意度</div>
              </div>
              <div className="space-y-4" data-id="element-302">
                <div className="bg-dark-900 p-4 rounded border border-white/5 flex items-center" data-id="element-303">
                  <div className="w-10 h-10 rounded-full bg-gray-700 flex-shrink-0 mr-4" data-id="element-304"></div>
                  <div data-id="element-305">
                    <div className="w-24 h-2 bg-gray-700 rounded mb-2" data-id="element-306"></div>
                    <div className="w-48 h-2 bg-gray-800 rounded" data-id="element-307"></div>
                  </div>
                </div>
                <div className="bg-dark-900 p-4 rounded border border-white/5 flex items-center opacity-70" data-id="element-308">
                  <div className="w-10 h-10 rounded-full bg-gray-700 flex-shrink-0 mr-4" data-id="element-309"></div>
                  <div data-id="element-310">
                    <div className="w-24 h-2 bg-gray-700 rounded mb-2" data-id="element-311"></div>
                    <div className="w-48 h-2 bg-gray-800 rounded" data-id="element-312"></div>
                  </div>
                </div>
                <div className="bg-dark-900 p-4 rounded border border-white/5 flex items-center opacity-40" data-id="element-313">
                  <div className="w-10 h-10 rounded-full bg-gray-700 flex-shrink-0 mr-4" data-id="element-314"></div>
                  <div data-id="element-315">
                    <div className="w-24 h-2 bg-gray-700 rounded mb-2" data-id="element-316"></div>
                    <div className="w-48 h-2 bg-gray-800 rounded" data-id="element-317"></div>
                  </div>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-318">
                <button className="text-gold-500 text-sm hover:text-white transition-colors" data-id="element-319">
                  查看客户评价 &rarr;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}